import DogMemberClubFee from '../dto/DogMemberClubFee.js';
import Error from '../model/Error.js';
import axios from 'axios';

export default class DogMemberClubFeeRepository {

    static findByMember(memberId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/members/${memberId}/dog-fees`)
                .then(response => resolve(response.data.data.map(data => DogMemberClubFee.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static delete(dogMemberClubFeeId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/dog-member-club-fees/${dogMemberClubFeeId}`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
    static create(memberId, memberClubFeeId, dogId) {
        const data = {
            memberClubFeeId: memberClubFeeId,
            dogId: dogId
        };
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/members/${memberId}/dog-fees`, data)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

}
